import React from 'react';
import { observer } from 'mobx-react';
import SnackbarStore from '../../store/SnackbarStore';
import { Alert, Snackbar } from '@mui/material';

export const CustomSnackbar = observer(({}) => {
  const handleClose = () => {
    SnackbarStore.toggleSnackbar(false);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={5000}
        severity="SnackbarStore.severity"
        open={SnackbarStore.toggle}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={SnackbarStore.severity} variant="filled" sx={{ width: '100%' }}>
          {SnackbarStore.message}
        </Alert>
      </Snackbar>
    </>
  );
});
